module.exports = __webpack_public_path__ + "static/assets/b642c68d2649e97467b58abfda3ccc4a.svg";